import type { IntlShape } from 'react-intl'
import { sortBy } from 'lib/array/arrayUtils'
import { getTrendingDestinationFilters } from './constants'

export const DEFAULT_TRENDING_DESTINATIONS_FILTER: App.DestinationSelectedFilters = 'hotel'

export function buildSortedTrendingDestinationFilterChips(
  currentRegionCode: string,
  intl: IntlShape,
  filterOrder?: Record<App.DestinationSelectedFilters, number>,
) {
  const filters = getTrendingDestinationFilters(currentRegionCode, intl)

  return sortBy(
    filters.map(filter => {
      let title: string
      if (filter.id === 'hotel') {
        title = intl.formatMessage({
          id: 'WOp2lqPGEarBxHAd9e2T',
          defaultMessage: 'Places to stay',
        })
      } else if (filter.id === 'cruise') {
        title = intl.formatMessage({
          id: 'yTBBpit4DJA7v0i8PYH5',
          defaultMessage: 'Cruising the seas',
        })
      } else {
        title = intl.formatMessage({
          id: 'C4mnyfmQpC4eLqgUbhZs',
          defaultMessage: 'Guided group tours',
        })
      }

      return {
        ...filter,
        title,
      }
    }),
    filter => filterOrder?.[filter.id] ?? Infinity,
    'asc',
  )
}
